const formatMokaPointCount = pointCount => `${pointCount} ${pointCount === 1 ? "point" : "points"}`;
export { formatMokaPointCount };